import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web.drivingzone/web.drivingzone/node_modules/next/dist/client/app-dir/link.js");
